import { Directive, HostListener, Output, EventEmitter, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appScrollTracker]',
  standalone: false,
})
export class ScrollTrackerDirective implements AfterViewInit, OnDestroy {
  @Output() scrollPosition = new EventEmitter<number>();

  private scrollElement: HTMLElement | null = null;
  private scrollHandler: ((event: Event) => void) | null = null;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    // Pour ion-content, nous devons accéder à l'élément de scroll interne
    setTimeout(() => {
      const element = this.elementRef.nativeElement;
      
      // Essayer différentes façons d'accéder à l'élément de scroll
      this.scrollElement = 
        element.shadowRoot?.querySelector('.inner-scroll') ||
        element.shadowRoot?.querySelector('.scroll-content') ||
        element.querySelector('.inner-scroll') ||
        element.querySelector('.scroll-content') ||
        element;
      
      if (this.scrollElement) {
        this.scrollHandler = (event: Event) => {
          const target = event.target as HTMLElement;
          this.scrollPosition.emit(target.scrollTop);
        };
        
        this.scrollElement.addEventListener('scroll', this.scrollHandler);
      }
    }, 200);
  }

  ngOnDestroy() {
    if (this.scrollElement && this.scrollHandler) {
      this.scrollElement.removeEventListener('scroll', this.scrollHandler);
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    this.scrollPosition.emit(target.scrollTop);
  }
}
